
import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbEnderecoIntegrador extends AppService {

  abstract getEnderecoCompleto(cep: number): Observable<any>;
  abstract salvarEndereco(id: number, endereco: any): Observable<any>;
  abstract getEndereco(id: number): Observable<any>;
  abstract obrigatoriedadeCampo(obrigatorio, campo): Boolean;

}